import {Service} from './service'
import apiHelper from '@utils/cunstomInterseptor'

export class WithdrawUSDTService extends Service {
  createWithdrawalUSDTRequest (params) {
    return apiHelper.post('/withdrawal_usdt_pending', params)
    // return this._apiRequestBuilder
    //   .withdrawalUsdt()
    //   .urlSegment('withdrawal_usdt_pending')
    //   .setParams(params)
    //   .post()
  }

  getWithdrawalUSDTRequestInfo (params) {
    return apiHelper.post('/get_withdrawal_delayed_usdt_by_internal_id', params)
    // return this._apiRequestBuilder
    //   .withdrawalUsdt()
    //   .urlSegment('get_withdrawal_delayed_usdt_by_internal_id')
    //   .setParams(params)
    //   .post()
  }

  applyWithdrawalUSDTRequest (params) {
    return apiHelper.post('/apply_withdrawal_usdt', params)
    // return this._apiRequestBuilder
    //   .withdrawalUsdt()
    //   .urlSegment('apply_withdrawal_usdt')
    //   .setParams(params)
    //   .post()
  }

  cancelWithdrawalUSDTRequest (params) {
    return apiHelper.post('/cancel_withdrawal_usdt', params)
    // return this._apiRequestBuilder
    //   .withdrawalUsdt()
    //   .urlSegment('cancel_withdrawal_usdt')
    //   .setParams(params)
    //   .post()
  }

  // getSubWallets (params) {
  //   return this._apiRequestBuilder
  //   .withdrawalUsdt()
  //   .urlSegment('get_subwallets')
  //   .setParams(params)
  //   .post()
  // }

  // getSubWalletsClients (params) {
  //   return this._apiRequestBuilder
  //   .withdrawalUsdt()
  //   .urlSegment('subwallet_client_list')
  //   .addQuery('user_id', params.user_id)
  //   .get()
  // }

  changeClietnBySubwallet (params) {
    return this._apiRequestBuilder
    .withdrawalUsdt()
    .urlSegment('change_client_name')
    .setParams(params)
    .put()
  }

  changeDesciptionBySubwallet (params) {
    return this._apiRequestBuilder
    .withdrawalUsdt()
    .urlSegment('change_description')
    .setParams(params)
    .put()
  }

  getApprowalsWithdrawalList (data) {
    const limit = 10
    const asset = data.asset
    const to = data.date.to
    const from = data.date.from
    // eslint-disable-next-line
    const user_id = data.id
    const status = data.status
    const offset = data.offset
        // eslint-disable-next-line
    const levels = data.levels

    return apiHelper.get('/get_withdrawal_list', {
      ...(limit !== null && { limit }),
      ...(offset !== null && { offset }),
      ...(asset !== null && { asset }),
      ...(to !== null && { to }),
      ...(from !== null && { from }),
      // eslint-disable-next-line
      ...(user_id !== null && { user_id }),
      ...(status !== null && { status }),
          // eslint-disable-next-line
      ...(levels !== null && { levels })
    })
  }

  getApproversList () {
    return apiHelper.get('/withdrawal_approver/get')
  }

  isDelegated () {
    return apiHelper.get('/withdrawal_approver/get?my_info=true')
  }

  getDelegatedList (offset) {
    return apiHelper.get(`/withdrawal_approver/get_delegations?limit=10&offset=${offset}`)
  }

  delegate (params) {
    return apiHelper.post('/withdrawal_approver/delegation/create', params)
  }

  getCurrentDelegationList () {
    return apiHelper.get('/withdrawal_approver/get_delegated_by_me')
  }

  getToMeDelegationList () {
    return apiHelper.get('/withdrawal_approver/get_delegated_to_me')
  }

  cancelDelegate (id) {
    return apiHelper.delete(`/withdrawal_approver/cancel/${id}`)
  }

  getSigns (id) {
    return apiHelper.get(`/get_withdrawal_signs?pending_withdrawal_id=${id}`)
  }

  getSignForHistory (id) {
    return apiHelper.get(`/get_withdrawal_signs?internal_id=${id}`)
  }
  getPendingById (id) {
    return apiHelper.get(`/get_withdrawal_details?pending_withdrawal_id=${id}`)
  }

  getWithdrawalDetailsByInternalId (id) {
    return apiHelper.get(`/get_withdrawal_details?internal_id=${id}`)
  }

  // getSubWalletsDescriptions (params) {
  //   return this._apiRequestBuilder
  //   .withdrawalUsdt()
  //   .urlSegment('subwallet_description_list')
  //   .addQuery('user_id', params.user_id)
  //   .get()
  // }

  // transfertToWallet (params) {
  //   return this._apiRequestBuilder
  //   .withdrawalUsdt()
  //   .urlSegment('transfer_asset_subwallet')
  //   .setParams(params)
  //   .put()
  // }

  // deleteSubWallet (params) {
  //   return this._apiRequestBuilder
  //   .withdrawalUsdt()
  //   .urlSegment('deactivate_subwallet')
  //   .setParams(params)
  //   .put()
  // }

  // createSubWallet (params) {
  //   return this._apiRequestBuilder
  //   .withdrawalUsdt()
  //   .urlSegment('create_subwallet')
  //   .setParams(params)
  //   .post()
  // }

  getHash (params) {
    return this._apiRequestBuilder
    .withdrawalUsdt()
    .urlSegment('withdrawal_usdt')
    .setParams(params)
    .post()
  }
}

export const withdrawUSDTService = new WithdrawUSDTService()



// WEBPACK FOOTER //
// ./src/js/services/withdraw_usdt.service.js